import React from 'react';
import { Slider as MuiSlider } from '@mui/material';
import styled from 'styled-components';

const StyledSlider = styled(MuiSlider)`
  height: 8px;

  &&&& .MuiSlider-mark {
    background-color: #555;
    height: 14px;
    margin-top: 1.5rem;
    width: 1px;
    opacity: 0.5;
  }

  &&& .MuiSlider-markLabel {
    color: #272727;
    font-size: 18px;
    top: 50px;
  }

  .MuiSlider-rail {
    background-color: #dfe3e6;
    border: 1px solid #dfe3e6;
    opacity: 1;
    padding-right: 0.5rem;
  }

  .MuiSlider-track {
    margin-left: -0.5rem;
    padding-left: 0.5rem;
  }

  .MuiSlider-thumb {
    border: 3px solid white;
    height: 35px;
    outline: 1px solid #dfe3e6;
    width: 35px;

    &:before {
      box-shadow: none;
    }
  }
`;

const StyledButtonContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
`;

const StyledDiv = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 25px 10px;
  width: 100%;

  @media (max-width: 575px) {
    padding: 12px 10px;
  }

  &:hover,
  &.selected {
    background-color: #006c9c;
    cursor: pointer;

    &&&& h3 {
      color: white;
    }
  }

  &&&& h3 {
    color: #272727;
    font-family: 'Whitney Medium', Arial, sans-serif;
    text-align: center;
    font-size: 1.25rem;
    line-height: 1.4375rem;
    font-weight: 500;
  }
`;

export function Slider({ selectedMark, marks, onChange }) {
  const [windowSize, setWindowSize] = React.useState(window.innerWidth);

  React.useEffect(() => {
    function handleResize() {
      // Update the state or perform any other actions when the
      // browser is resized
      setWindowSize(window.innerWidth);
    }

    // Attach the event listener to the window object
    window.addEventListener('resize', handleResize);

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (windowSize <= 768) {
    return (
      <StyledButtonContainer>
        {marks.map((mark) => (
          <StyledDiv
            className={selectedMark == mark && 'selected'}
            onClick={() => onChange(mark.value)}
            value={mark.value}
          >
            <h3>{mark.label}</h3>
          </StyledDiv>
        ))}
      </StyledButtonContainer>
    );
  } else {
    return (
      <StyledSlider
        value={selectedMark && selectedMark.value}
        step={null}
        marks={marks}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
}
